import { createSelector } from "reselect";
const selector = (state) => state.divisions;

export default createSelector([selector], (data) => data);